import { render, staticRenderFns } from "./additionalChargesPopup.vue?vue&type=template&id=47ae32f6&scoped=true&"
import script from "./additionalChargesPopup.vue?vue&type=script&lang=js&"
export * from "./additionalChargesPopup.vue?vue&type=script&lang=js&"
import style0 from "./additionalChargesPopup.vue?vue&type=style&index=0&id=47ae32f6&scoped=true&lang=css&"
import style1 from "./additionalChargesPopup.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./additionalChargesPopup.vue?vue&type=style&index=2&id=47ae32f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ae32f6",
  null
  
)

export default component.exports